import { render, staticRenderFns } from "./ModelInfo.vue?vue&type=template&id=07a746ab&scoped=true&"
import script from "./ModelInfo.vue?vue&type=script&lang=js&"
export * from "./ModelInfo.vue?vue&type=script&lang=js&"
import style0 from "./ModelInfo.vue?vue&type=style&index=0&id=07a746ab&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a746ab",
  null
  
)

export default component.exports